import type {
  NestedDockmasterSpan,
  SpanEvent,
} from "../../../../../../../schemas";
import { useEventHighlightActions } from "../EventHighlightStore";
import { TimelineWithEvents } from "./TimelineWithEvents";
import { SpanTiming, TraceEventItem } from "./TraceEventItem";

interface EventsSectionProps {
  span: NestedDockmasterSpan;
}

export function TraceEvents({ span }: EventsSectionProps) {
  // Handle both new events format and old attributes format
  const events = span.events || span.attributes || [];
  const { setHighlightedEventId } = useEventHighlightActions();

  let startTime = span.startTime;

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-foreground">Timeline</h4>
      <div className="space-y-3">
        {/* Timeline with event dots */}
        <div className="px-1">
          <TimelineWithEvents span={span} events={events} />
        </div>
        {/* Events list */}
        <div className="grid grid-cols-[auto_1fr] min-w-0 overflow-hidden">
          {/* Header row */}
          <div className="contents">
            <div className="h-full flex items-center p-2 font-medium border-b mb-2 text-center">
              Timing
            </div>
            <div className="h-full flex items-center p-2 font-medium border-b mb-2">
              Event
            </div>
          </div>
          {/* Start event */}
          <div className="contents">
            <div className="flex justify-between pl-2">
              <div className="flex items-center justify-center">
                <div className="flex flex-col items-center h-full">
                  <div className="flex-1" />
                  <div className="w-3 h-3 rounded-full border-2 border-muted-foreground bg-background shadow-sm flex-shrink-0" />
                  <div className="flex-1 w-px bg-border" />
                </div>
              </div>
              <SpanTiming>+0ms</SpanTiming>
            </div>
            <div className="flex items-center py-2">
              <div className="text-muted-foreground">Start</div>
            </div>
          </div>

          {events.map((event: SpanEvent, index: number) => {
            const eventId = `${span.spanId}-event-${index}`;
            // Store the start time before updating it already for the next iteration
            const previousStartTime = startTime;
            startTime = event.time;

            return (
              <TraceEventItem
                startTime={previousStartTime}
                key={eventId}
                event={event}
                eventId={eventId}
                onMouseEnter={() => setHighlightedEventId(eventId)}
                onMouseLeave={() => setHighlightedEventId(null)}
              />
            );
          })}
          {/* End event */}
          <div className="contents">
            <div className="flex justify-between pl-2">
              <div className="flex items-center justify-center">
                <div className="flex flex-col items-center h-full">
                  <div className="flex-1 w-px bg-border" />
                  <div className="w-3 h-3 rounded-full border-2 border-muted-foreground bg-background shadow-sm flex-shrink-0" />
                  <div className="flex-1" />
                </div>
              </div>
              <SpanTiming>
                +{(span.endTime ?? startTime) - startTime} ms
              </SpanTiming>
            </div>
            <div className="flex items-center py-2 px-1">
              <div className="text-muted-foreground">End</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
